<script>
import ActionModal from "@/components/setting-template/bundle-invoice/modal/action";
export default {
    extends: ActionModal
};
</script>
